import URLSearchParams from '@ungap/url-search-params';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);

/**
 * Text format for total of guest
 * @author Dat Doan
 * @date 2021-07-07
 * @param {Number} numberOfGuest
 * @returns {String}
 */
export const getTotalGuestFormatting = (numberOfGuest) => {
  if (numberOfGuest === 0) {
    return 'Add guest';
  } else if (numberOfGuest === 1) {
    return `${numberOfGuest} person`;
  }
  return `${numberOfGuest} people`;
};

/**
 * Check for valid dates
 * @date 2021-03-02
 * @param {dayjs date} dateFromValue
 * @param {dayjs date} dateToValue
 * @returns {boolean}
 */
export const isCheckInAndCheckOutDateIsValid = (dateFromValue, dateToValue) => {
  return (
    dayjs(dateFromValue).isValid() &&
    dayjs(dateToValue).isValid() &&
    dayjs().isSameOrBefore(dayjs(dateFromValue), 'day') &&
    dayjs(dateFromValue).isSameOrBefore(dayjs(dateToValue), 'day')
  );
};

/**
 * Return links parameters
 * @author Dat Doan
 * @date 2021-08-20
 * @param {string} locationSearch
 * @returns {{isHasParamsDates:boolean, paramDateFrom:string, paramDateTo:string}}
 */
export const getParamsValues = (locationSearch) => {
  // Search url params
  const urlParams = new URLSearchParams(locationSearch);
  // Check for url params
  const isHasParamsDates = urlParams.has('dateFrom') && urlParams.has('dateTo');
  const paramDateFrom = urlParams.get('dateFrom');
  const paramDateTo = urlParams.get('dateTo');

  return {
    isHasParamsDates,
    paramDateFrom,
    paramDateTo,
  };
};
